import { cn } from '@/lib/utils'

interface SegmentedProps<T extends string> {
  value: T
  onChange: (value: T) => void
  options: { value: T; label: React.ReactNode }[]
  className?: string
}

/** Grey track with a white selected pill, as the admin's index-table tabs. */
export const Segmented = <T extends string>({ value, onChange, options, className }: SegmentedProps<T>) => (
  <div role="radiogroup" className={cn('inline-flex max-w-full overflow-x-auto rounded-md bg-fill p-0.5 scrollbar-hide', className)}>
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        role="radio"
        aria-checked={value === o.value}
        onClick={() => onChange(o.value)}
        className={cn(
          'h-8 flex-1 whitespace-nowrap rounded-sm px-3 text-sm font-medium text-text-2 transition-colors',
          value === o.value ? 'bg-card text-ink shadow-z1' : 'hover:text-ink'
        )}
      >
        {o.label}
      </button>
    ))}
  </div>
)
